import { defineComponent, onMounted, ref, watch, } from '@vue/composition-api';
import { getStructuresList, getCentralCostList, } from '@/api/requests/structures';
import { BudgetTreeNode } from '@/views/Brand/Places/_components/budget-tree-node';
import { BudgetSummary } from '@/views/Brand/Places/_components/budget-summary';
import { useAuthUser, useBrand, useRouteQuery } from '@/composables';
import BackdropLoader from '@/components/BackdropLoader/BackdropLoader.vue';
import { SystemRole } from '@/api/requests/users';
import { useUpdatesCounter } from '@/composables/use-updates-counter';
import { fetchAllItems } from '@/util/api';
import { useViewer } from '@/composables/use-viewer';
export default defineComponent({
    components: { BackdropLoader, BudgetSummary, BudgetTreeNode },
    setup(_, ctx) {
        const centralCost = ref(null);
        const params = ctx.root.$route.params;
        const structures = ref([]);
        const rootStructure = ref(null);
        const { brand } = useBrand();
        const isLoading = ref(false);
        const { hasRole: hasAuthUserRole } = useAuthUser();
        const { isPreviewMode, hasRole: hasViewerRole } = useViewer(ctx);
        const { update, updatesCounter } = useUpdatesCounter();
        const { routeQuery } = useRouteQuery(ctx);
        const handleOnBudgetAccept = () => {
            fetchStructure();
            update();
        };
        const fetchRootStructure = async () => {
            const { nodes } = await getStructuresList({
                //TODO remove
                // parentId: 'null',
                brandId: params.id,
                centralCostId: centralCost.value?.id,
                withBudget: true,
                containPlace: routeQuery.value.q,
            });
            rootStructure.value = nodes[0];
        };
        watch(routeQuery, () => fetchStructure());
        const checkRole = (role) => {
            if (isPreviewMode.value) {
                return hasViewerRole(role);
            }
            return hasAuthUserRole(role);
        };
        const resolveSystemRoleParam = () => {
            switch (true) {
                case checkRole(SystemRole.STRUCTURE_MANAGER):
                case checkRole(SystemRole.PLACE_MANAGER):
                    return { showNested: true };
                default:
                    return { parentId: rootStructure.value?.id };
            }
        };
        const fetchStructure = async () => {
            if (!centralCost.value?.id) {
                return;
            }
            try {
                isLoading.value = true;
                await fetchRootStructure();
                structures.value = await fetchAllItems('structures', {
                    ...resolveSystemRoleParam(),
                    brandId: params.id,
                    centralCostId: centralCost.value.id,
                    withBudget: true,
                    containPlace: routeQuery.value.q,
                }, [], true);
            }
            finally {
                isLoading.value = false;
            }
        };
        const onCentralCostUpdate = async (value) => {
            centralCost.value = value;
            await fetchStructure();
        };
        onMounted(async () => {
            const { nodes } = await getCentralCostList({
                perPage: 1,
                page: 1,
                brandId: params.id,
            });
            centralCost.value = nodes[0];
            await fetchStructure();
        });
        return {
            structures,
            brand,
            centralCost,
            fetchStructure,
            onCentralCostUpdate,
            rootStructure,
            isLoading,
            handleOnBudgetAccept,
            updatesCounter,
        };
    },
});
